Customer.Dashboard ||= {}

class Customer.Dashboard.TicketHistoryView extends Backbone.View

  events:
    'change .history-selector': '_updateHistory'

  initialize: (@options = {}) ->
    @ticketId = @options.ticketId
    @hasAllHistory = false

  show: ->
    @$el.modal()
    @$el.find('.nano-content').html('').addClass('processing')
    @_resetSelectorsToDefault()
    @hasAllHistory = false
    @_retrieveConversationEvents()

  _resetSelectorsToDefault: ->
    @$el.find('#interaction-selector').prop('checked', false)
    @$el.find('#conversation-selector').prop('checked', true)

  _retrieveConversationEvents: ->
    @_disableSelectors()
    $.ajax
      type: 'POST'
      url: '/customer/conversations/history'
      data:
        id: @ticketId
        interaction_events: false
      success: @_renderSearchResults

  _renderSearchResults: (response) =>
    return unless response.events
    @events = new Customer.Ticket.ConversationHistoryEventCollection(response.events || [])
    @_renderEvents @events.models
    @_reEnableSelectors()

  _disableSelectors: ->
    @$el.find('#interaction-selector').prop('disabled', true)
    @$el.find('#conversation-selector').prop('disabled', true)

  _reEnableSelectors: ->
    @$el.find('#interaction-selector').prop('disabled', false)
    @$el.find('#conversation-selector').prop('disabled', false)

  _updateHistory: =>
    @$el.find('.nano-content').addClass('processing').html('')
    return @_retrieveAllThenRender() if @_needInteractionEvents()
    @_renderEvents @_filteredEvents()

  _needInteractionEvents: ->
    @$el.find('#interaction-selector').is(':checked') and not @hasAllHistory

  _retrieveAllThenRender: ->
    @_disableSelectors()
    $.ajax
      type: 'POST'
      url: '/customer/conversations/history'
      data:
        id: @ticketId
      success: @_renderRetrievedEvents

  _renderRetrievedEvents: (response) =>
    return unless response.events
    @hasAllHistory = true
    @events = new Customer.Ticket.ConversationHistoryEventCollection(response.events || [])
    @_renderEvents @_filteredEvents()
    @_reEnableSelectors()

  _filteredEvents: ->
    selected = []
    unless @$el.find('#interaction-selector').is ':checked'
      selected.push('interaction_event')
    unless @$el.find('#conversation-selector').is ':checked'
      selected.push('conversation_event', 'conversation_attribute_event', 'response_schedule_event')
    @events.filter((event) -> event.get('type') not in selected)

  _renderEvents: (events) ->
    @$el.find('.nano-content').removeClass('processing').html(
      $('<div></div>').attr('id', 'social-content-history')
    )
    events.forEach((event) => @_renderEvent(event))
    @_refreshScrollerWhenReady()

  _renderEvent: (event) ->
    eventView = new Customer.Dashboard.TicketHistoryEventView
      event: event
    renderedView = eventView.render()
    if renderedView
      @$el.find('#social-content-history').append renderedView.el

  _refreshScrollerWhenReady: ->
    return setTimeout(@_refreshScrollerWhenReady(), 100) unless @_scrollableAreaReady()
    @$el.find('#nano-history').nanoScroller().nanoScroller
      scroll: 'bottom'

  _scrollableAreaReady: ->
    @$el.find('#nano-history')[0].scrollHeight > 0
